"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ToolBar;

var _HistoryRounded2 = _interopRequireDefault(require("@material-ui/icons/HistoryRounded"));

var _IconButton2 = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _DeleteRounded2 = _interopRequireDefault(require("@material-ui/icons/DeleteRounded"));

var _VisibilityRounded2 = _interopRequireDefault(require("@material-ui/icons/VisibilityRounded"));

var _EventRounded2 = _interopRequireDefault(require("@material-ui/icons/EventRounded"));

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _ArrowDropDownCircleRounded2 = _interopRequireDefault(require("@material-ui/icons/ArrowDropDownCircleRounded"));

var _styles = require("@material-ui/core/styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("../components/Button"));

var _Filter = _interopRequireDefault(require("./Filter"));

var _Group = _interopRequireDefault(require("./Group"));

var _Hide = _interopRequireDefault(require("./Hide"));

var _Share = _interopRequireDefault(require("./Share"));

var _Sort = _interopRequireDefault(require("./Sort"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    container: {
      borderTop: "1px solid #e0e0e2",
      borderBottom: "1px solid #e0e0e2",
      padding: "0.5rem"
    },
    item: {
      marginRight: 6,
      "& button": {
        fontWeight: 600
      }
    },
    rightButtom: {
      marginRight: 6
    }
  };
});
ToolBar.propTypes = {
  fields: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    type: _propTypes["default"].string,
    options: _propTypes["default"].object
  })),
  hide: _propTypes["default"].objectOf(_propTypes["default"].shape({
    value: _propTypes["default"].array,
    onChange: _propTypes["default"].func
  })),
  sort: _propTypes["default"].objectOf(_propTypes["default"].shape({
    value: _propTypes["default"].object,
    onChange: _propTypes["default"].func
  })),
  group: _propTypes["default"].objectOf(_propTypes["default"].shape({
    value: _propTypes["default"].object,
    onChange: _propTypes["default"].func
  })),
  filter: _propTypes["default"].objectOf(_propTypes["default"].shape({
    value: _propTypes["default"].array,
    onChange: _propTypes["default"].func,
    onSubmit: _propTypes["default"].func,
    onOpenInput: _propTypes["default"].func,
    onClose: _propTypes["default"].func
  })),
  share: _propTypes["default"].objectOf(_propTypes["default"].shape({
    value: _propTypes["default"].object,
    onChange: _propTypes["default"].func,
    isLoading: _propTypes["default"].bool
  })),
  stack: _propTypes["default"].objectOf(_propTypes["default"].shape({
    value: _propTypes["default"].string,
    onClick: _propTypes["default"].func
  })),
  calendar: _propTypes["default"].objectOf(_propTypes["default"].shape({
    value: _propTypes["default"].string,
    onClick: _propTypes["default"].func
  })),
  onClickDelete: _propTypes["default"].func,
  disableDelete: _propTypes["default"].bool,
  onClickHistory: _propTypes["default"].func,
  onClickOpenForm: _propTypes["default"].func
};

function ToolBar(_ref) {
  var fields = _ref.fields,
      hide = _ref.hide,
      filter = _ref.filter,
      sort = _ref.sort,
      group = _ref.group,
      share = _ref.share,
      stack = _ref.stack,
      calendar = _ref.calendar,
      onClickDelete = _ref.onClickDelete,
      disableDelete = _ref.disableDelete,
      onClickHistory = _ref.onClickHistory,
      onClickOpenForm = _ref.onClickOpenForm;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    className: classes.container,
    display: "flex",
    justifyContent: "space-between"
  }, /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    display: "flex"
  }, stack && /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    className: classes.item
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: stack.onClick,
    size: "small",
    startIcon: /*#__PURE__*/_react["default"].createElement(_ArrowDropDownCircleRounded2["default"], {
      fontSize: "small"
    })
  }, "Stacked by ", stack.value)), calendar && /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    className: classes.item
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: calendar.onClick,
    size: "small",
    startIcon: /*#__PURE__*/_react["default"].createElement(_EventRounded2["default"], {
      fontSize: "small"
    })
  }, "Using \"", calendar.value, "\" field")), hide && /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    className: classes.item
  }, /*#__PURE__*/_react["default"].createElement(_Hide["default"], _extends({
    fields: fields
  }, hide))), filter && /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    className: classes.item
  }, /*#__PURE__*/_react["default"].createElement(_Filter["default"], _extends({
    fields: fields
  }, filter))), group && /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    className: classes.item
  }, /*#__PURE__*/_react["default"].createElement(_Group["default"], _extends({
    fields: fields
  }, group))), sort && /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    className: classes.item
  }, /*#__PURE__*/_react["default"].createElement(_Sort["default"], _extends({
    fields: fields
  }, sort))), share && /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    className: classes.item
  }, /*#__PURE__*/_react["default"].createElement(_Share["default"], _extends({
    fields: fields
  }, share))), onClickOpenForm && /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    className: classes.item
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: onClickOpenForm,
    size: "small",
    startIcon: /*#__PURE__*/_react["default"].createElement(_VisibilityRounded2["default"], {
      fontSize: "small"
    })
  }, "Open Form"))), /*#__PURE__*/_react["default"].createElement(_Box2["default"], null, onClickDelete && /*#__PURE__*/_react["default"].createElement(_IconButton2["default"], {
    className: classes.rightButtom,
    disabled: disableDelete,
    onClick: onClickDelete,
    size: "small"
  }, /*#__PURE__*/_react["default"].createElement(_DeleteRounded2["default"], {
    style: {
      color: disableDelete ? "silver" : "#031330"
    },
    fontSize: "small"
  })), onClickHistory && /*#__PURE__*/_react["default"].createElement(_IconButton2["default"], {
    className: classes.rightButtom,
    onClick: onClickHistory,
    size: "small"
  }, /*#__PURE__*/_react["default"].createElement(_HistoryRounded2["default"], {
    style: {
      color: "#031330"
    },
    fontSize: "small"
  }))));
}